import { cn } from "@/lib/utils";
import { Image } from "lucide-react";

interface ImageLoadingSkeletonProps {
  className?: string;
}

export function ImageLoadingSkeleton({ className }: ImageLoadingSkeletonProps) {
  return (
    <div className={cn("group flex justify-start", className)}>
      <div className="flex flex-col gap-2 w-full">
        <div className="rounded-lg w-full">
          <div className="flex flex-col gap-2 w-full">
            <div className="mt-2 relative">
              <div
                className="bg-muted animate-pulse rounded-lg shadow-md flex items-center justify-center aspect-square max-w-full"
                style={{ maxHeight: "400px", width: "min(100%, 400px)" }}
              >
                <Image className="w-12 h-12 text-muted-foreground/40 animate-pulse" />
              </div>
            </div>
            <div className="flex items-center gap-2 px-2">
              <div className="w-2 h-2 bg-foreground/40 rounded-full animate-pulse" />
              <span className="text-sm text-muted-foreground">Generating image...</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

